var _rect, _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 61,
    viewBox: "0 0 82 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 69.9981,
    height: 56.5853,
    rx: 11,
    fill: "#1F283E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8979C0 4.87916 4.87916 0 10.8979 0H59.1002C65.1189 0 69.9981 4.87916 69.9981 10.8979H0Z",
    fill: "#022DEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.01156,
    cy: 4.82113,
    r: 1.6766,
    fill: "#305F1A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0897,
    cy: 4.82113,
    r: 1.6766,
    fill: "#96D36E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1668,
    cy: 4.82113,
    r: 1.6766,
    fill: "#519F2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M7.33497 18.2101C7.33614 17.4051 7.57602 16.6186 8.02429 15.9499C8.47255 15.2813 9.10906 14.7606 9.85329 14.4537C10.5975 14.1469 11.416 14.0676 12.2053 14.2261C12.9946 14.3845 13.7191 14.7734 14.2873 15.3437C14.8555 15.9139 15.2418 16.6399 15.3973 17.4297C15.5529 18.2195 15.4707 19.0378 15.1611 19.7809C14.8516 20.524 14.3286 21.1586 13.6583 21.6044C12.988 22.0503 12.2006 22.2873 11.3956 22.2855C10.8613 22.2849 10.3323 22.179 9.83895 21.9738C9.34559 21.7686 8.89753 21.4682 8.52039 21.0897C8.14325 20.7112 7.84444 20.262 7.64103 19.7679C7.43763 19.2738 7.33362 18.7445 7.33497 18.2101Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M15.474 28.3865C15.4739 29.1915 15.2351 29.9784 14.7877 30.6476C14.3403 31.3169 13.7044 31.8384 12.9606 32.1462C12.2168 32.454 11.3983 32.5343 10.6089 32.3769C9.81938 32.2195 9.09431 31.8315 8.52538 31.262C7.95645 30.6925 7.56922 29.967 7.41266 29.1774C7.25611 28.3877 7.33726 27.5694 7.64587 26.8259C7.95448 26.0823 8.47667 25.4471 9.14638 25.0004C9.8161 24.5537 10.6032 24.3157 11.4083 24.3164C11.9425 24.3166 12.4714 24.4221 12.9649 24.6268C13.4584 24.8314 13.9067 25.1313 14.2842 25.5093C14.6618 25.8872 14.9612 26.3358 15.1653 26.8295C15.3695 27.3232 15.4744 27.8522 15.474 28.3865ZM11.4072 30.4264C11.8093 30.4248 12.2019 30.304 12.5354 30.0794C12.8689 29.8548 13.1283 29.5364 13.2809 29.1644C13.4335 28.7924 13.4724 28.3835 13.3927 27.9894C13.313 27.5953 13.1183 27.2336 12.8332 26.9501C12.5481 26.6666 12.1853 26.474 11.7907 26.3966C11.3962 26.3192 10.9875 26.3604 10.6164 26.5152C10.2453 26.6699 9.92836 26.9312 9.70566 27.266C9.48297 27.6007 9.3645 27.994 9.36522 28.3961C9.36851 28.9356 9.58509 29.4518 9.96766 29.8322C10.3502 30.2125 10.8677 30.4261 11.4072 30.4263V30.4264Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.6854 16.1934V18.1903H17.5303V16.1934H27.6854Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.6819 24.304H17.5342V22.3008H27.6819V24.304Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.5166 30.4131C17.5166 29.7739 17.5166 29.1556 17.5177 28.5354C17.5197 28.4948 17.524 28.4542 17.5305 28.4141H27.6858V30.4131H17.5166Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M24.6274 47.0781H15.1201V60.8235H24.6274V47.0781Z",
    fill: "#022DEC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M36.0815 35.623H26.5742V60.823H36.0815V35.623Z",
    fill: "#022DEC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M47.422 40.2051H38.0293V60.8232H47.422V40.2051Z",
    fill: "#022DEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M58.6466 24.3984H49.2539V60.8238H58.6466V24.3984Z",
    fill: "#022DEC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M70.3305 30.0117H60.8232V60.8244H70.3305V30.0117Z",
    fill: "#022DEC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M81.3266 38.4883H71.8193V60.8246H81.3266V38.4883Z",
    fill: "#022DEC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOms);
export default __webpack_public_path__ + "static/media/oms.e455aff7a32229662cddb586f1c04338.svg";
export { ForwardRef as ReactComponent };